import React from 'react';
import { useIntl } from 'react-intl';
import { StyleSheet, View, Platform } from 'react-native';
import ErrorIcon from '../../icons/ErrorIcon';
import defaultTranslations from '../../Translations/en.json';
import { useTheme, Button, Typography } from '@hmsexp/component-library';
import getDeviceType from '../../utils/getDeviceType';
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    minheight: 200,
    padding: 20
  },
  textContainer: {
    marginTop: 20,
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonContainer: {
    width: 100,
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center'
  }
});

const { isDesktopBrowser } = getDeviceType();

const ErrorCard = ({ handleRefresh = () => {}, containerStyles, style, errorCardStyle }) => {
  const intl = useIntl();
  const { palette } = useTheme();
  return (
    <View
      style={[
        styles.container,
        isDesktopBrowser ? containerStyles : style,
        {
          backgroundColor: palette['background']
        },
        errorCardStyle
      ]}
    >
      {isDesktopBrowser ? <ErrorIcon /> : <ErrorIcon width='70' height='70' />}
      <View style={styles.textContainer}>
        <Typography variant={'caption'}>
          {intl.formatMessage({
            id: 'HOME_COMMON_ERROR_TEXT',
            defaultMessage: defaultTranslations.HOME_COMMON_ERROR_TEXT
          })}
        </Typography>
      </View>
      <View style={styles.buttonContainer}>
        <Button
          title={intl.formatMessage({
            id: 'REFRESH',
            defaultMessage: defaultTranslations.REFRESH
          })}
          size={isDesktopBrowser ? 'medium' : 'mini'}
          onClick={handleRefresh}
        />
      </View>
    </View>
  );
};

export default ErrorCard;
